var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 1.578L10 2.4l-.824-.824a5.375 5.375 0 00-7.601 7.602l7.895 7.895a.75.75 0 001.06 0l7.902-7.897a5.376 5.376 0 10-7.612-7.598z",
    fill: "#333230"
  })));
}
export default SvgPldHeartFilled;